import React from 'react';
import CheckIcon from '@/svgs/check.svg?react';
import CheckoutPlanButton from '@/Components/Billing/CheckoutPlanButton';

interface PlanCardProps {
  active: boolean;
  plan: any;
}

export default function PlanCard({ plan, active }: PlanCardProps) {
  const dollars =
    plan.interval === 'monthly'
      ? plan.price.raw / 100
      : plan.price.raw / (100 * 12);
  const price = dollars.toLocaleString('en-US', {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  });

  const planTitleMap: {
    [key in App.Enums.Plan]: JSX.Element;
  } = {
    free: (
      <h1 className="text-lg font-semibold dark:text-brand-light-100">
        Starter
      </h1>
    ),
    pro: (
      <h1 className="text-lg font-semibold dark:text-brand-light-100">
        Professional{' '}
        <span className="text-xs font-normal text-brand dark:text-brand-dark">
          Most popular
        </span>
      </h1>
    ),
    agency: (
      <h1 className="text-lg font-semibold dark:text-brand-light-100">
        Agency{' '}
        <span className="rounded bg-brand-dark-25 p-1 text-xs font-normal text-brand-light-50">
          Coming soon
        </span>
      </h1>
    ),
  };

  return (
    <div className="flex h-full flex-col justify-between gap-4 rounded-xl border border-brand-dark-20 p-4">
      <div>
        {planTitleMap[plan.slug as App.Enums.Plan]}
        <p className="pb-4 pt-1 text-sm">{plan.description}</p>
        <p className="border-b border-b-brand-dark-20 pb-4">
          <sup className="dark:text-brand-light-100">$</sup>
          <span className="text-xl font-semibold dark:text-brand-light-100">
            {price}
          </span>
          /
          <span className=" font-normal">
            monthly {plan.interval === 'yearly' ? ', billed annually' : ''}
          </span>
        </p>
        <ul className="pt-4">
          {plan.features.map((feature: string) => (
            <li
              className="flex items-center gap-1 pt-3 text-sm dark:text-brand-light-75"
              key={feature}
            >
              <CheckIcon className="h-4 w-4 text-current" />
              {feature}
            </li>
          ))}
        </ul>
      </div>

      <CheckoutPlanButton plan={plan} active={active} />
    </div>
  );
}
